// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const HUGGINGFACE_MODELS = {
	"MiniMaxAI/MiniMax-M2": {
		id: "MiniMaxAI/MiniMax-M2",
		name: "MiniMax-M2",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 128000,
	} satisfies Model<"openai-completions">,
	"MiniMaxAI/MiniMax-M2.1": {
		id: "MiniMaxAI/MiniMax-M2.1",
		name: "MiniMax-M2.1",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"MiniMaxAI/MiniMax-M2.5": {
		id: "MiniMaxAI/MiniMax-M2.5",
		name: "MiniMax-M2.5",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"MiniMaxAI/MiniMax-M2.7": {
		id: "MiniMaxAI/MiniMax-M2.7",
		name: "MiniMax-M2.7",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"MiniMaxAI/MiniMax-M3": {
		id: "MiniMaxAI/MiniMax-M3",
		name: "MiniMax-M3",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 524288,
		maxTokens: 128000,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-235B-A22B": {
		id: "Qwen/Qwen3-235B-A22B",
		name: "Qwen3 235B-A22B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.2,
			output: 0.8,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 40960,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-235B-A22B-Thinking-2507": {
		id: "Qwen/Qwen3-235B-A22B-Thinking-2507",
		name: "Qwen3-235B-A22B-Thinking-2507",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-32B": {
		id: "Qwen/Qwen3-32B",
		name: "Qwen3 32B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.29,
			output: 0.59,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-Coder-30B-A3B-Instruct": {
		id: "Qwen/Qwen3-Coder-30B-A3B-Instruct",
		name: "Qwen3-Coder 30B-A3B Instruct",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.07,
			output: 0.26,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-Coder-480B-A35B-Instruct": {
		id: "Qwen/Qwen3-Coder-480B-A35B-Instruct",
		name: "Qwen3-Coder-480B-A35B-Instruct",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 2,
			output: 2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 66536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-Coder-Next": {
		id: "Qwen/Qwen3-Coder-Next",
		name: "Qwen3-Coder-Next",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.2,
			output: 1.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-Next-80B-A3B-Instruct": {
		id: "Qwen/Qwen3-Next-80B-A3B-Instruct",
		name: "Qwen3-Next-80B-A3B-Instruct",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.25,
			output: 1,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 66536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3-Next-80B-A3B-Thinking": {
		id: "Qwen/Qwen3-Next-80B-A3B-Thinking",
		name: "Qwen3-Next-80B-A3B-Thinking",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.5-122B-A10B": {
		id: "Qwen/Qwen3.5-122B-A10B",
		name: "Qwen3.5 122B-A10B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 3.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.5-27B": {
		id: "Qwen/Qwen3.5-27B",
		name: "Qwen3.5 27B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 2.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.5-35B-A3B": {
		id: "Qwen/Qwen3.5-35B-A3B",
		name: "Qwen3.5 35B-A3B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.5-397B-A17B": {
		id: "Qwen/Qwen3.5-397B-A17B",
		name: "Qwen3.5-397B-A17B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 3.6,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.5-9B": {
		id: "Qwen/Qwen3.5-9B",
		name: "Qwen3.5 9B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.17,
			output: 0.25,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.6-27B": {
		id: "Qwen/Qwen3.6-27B",
		name: "Qwen3.6 27B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.47,
			output: 3.19,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"Qwen/Qwen3.6-35B-A3B": {
		id: "Qwen/Qwen3.6-35B-A3B",
		name: "Qwen3.6 35B-A3B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.15,
			output: 0.95,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"XiaomiMiMo/MiMo-V2-Flash": {
		id: "XiaomiMiMo/MiMo-V2-Flash",
		name: "MiMo-V2-Flash",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.1,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 4096,
	} satisfies Model<"openai-completions">,
	"XiaomiMiMo/MiMo-V2.5-Pro": {
		id: "XiaomiMiMo/MiMo-V2.5-Pro",
		name: "MiMo-V2.5-Pro",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1,
			output: 3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"deepseek-ai/DeepSeek-R1": {
		id: "deepseek-ai/DeepSeek-R1",
		name: "DeepSeek-R1",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.7,
			output: 2.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 64000,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"deepseek-ai/DeepSeek-R1-0528": {
		id: "deepseek-ai/DeepSeek-R1-0528",
		name: "DeepSeek-R1-0528",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 3,
			output: 5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 163840,
		maxTokens: 163840,
	} satisfies Model<"openai-completions">,
	"deepseek-ai/DeepSeek-V3.2": {
		id: "deepseek-ai/DeepSeek-V3.2",
		name: "DeepSeek-V3.2",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.28,
			output: 0.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 163840,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"deepseek-ai/DeepSeek-V4-Flash": {
		id: "deepseek-ai/DeepSeek-V4-Flash",
		name: "DeepSeek V4 Flash",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 384000,
	} satisfies Model<"openai-completions">,
	"deepseek-ai/DeepSeek-V4-Pro": {
		id: "deepseek-ai/DeepSeek-V4-Pro",
		name: "DeepSeek V4 Pro",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.435,
			output: 0.87,
			cacheRead: 0.003625,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 393216,
	} satisfies Model<"openai-completions">,
	"google/gemma-4-26B-A4B-it": {
		id: "google/gemma-4-26B-A4B-it",
		name: "Gemma 4 26B A4B IT",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.13,
			output: 0.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"google/gemma-4-31B-it": {
		id: "google/gemma-4-31B-it",
		name: "Gemma 4 31B IT",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.14,
			output: 0.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"meta-llama/Llama-3.3-70B-Instruct": {
		id: "meta-llama/Llama-3.3-70B-Instruct",
		name: "Llama-3.3-70B-Instruct",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.59,
			output: 0.79,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 4096,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2-Instruct": {
		id: "moonshotai/Kimi-K2-Instruct",
		name: "Kimi-K2-Instruct",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1,
			output: 3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2-Instruct-0905": {
		id: "moonshotai/Kimi-K2-Instruct-0905",
		name: "Kimi-K2-Instruct-0905",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 1,
			output: 3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2-Thinking": {
		id: "moonshotai/Kimi-K2-Thinking",
		name: "Kimi-K2-Thinking",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.5,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2.5": {
		id: "moonshotai/Kimi-K2.5",
		name: "Kimi-K2.5",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 3,
			cacheRead: 0.1,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2.6": {
		id: "moonshotai/Kimi-K2.6",
		name: "Kimi-K2.6",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.16,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"moonshotai/Kimi-K2.7-Code": {
		id: "moonshotai/Kimi-K2.7-Code",
		name: "Kimi K2.7 Code",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-120b": {
		id: "openai/gpt-oss-120b",
		name: "GPT OSS 120B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.25,
			output: 0.69,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-20b": {
		id: "openai/gpt-oss-20b",
		name: "GPT OSS 20B",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.1,
			output: 0.5,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"stepfun-ai/Step-3.5-Flash": {
		id: "stepfun-ai/Step-3.5-Flash",
		name: "Step 3.5 Flash",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.1,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 256000,
	} satisfies Model<"openai-completions">,
	"stepfun-ai/Step-3.7-Flash": {
		id: "stepfun-ai/Step-3.7-Flash",
		name: "Step 3.7 Flash",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 1.15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 256000,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-4.5": {
		id: "zai-org/GLM-4.5",
		name: "GLM-4.5",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 98304,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-4.5-Air": {
		id: "zai-org/GLM-4.5-Air",
		name: "GLM-4.5-Air",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.13,
			output: 0.85,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 98304,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-4.5V": {
		id: "zai-org/GLM-4.5V",
		name: "GLM-4.5V",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 1.8,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 65536,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-4.6": {
		id: "zai-org/GLM-4.6",
		name: "GLM-4.6",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.55,
			output: 2.2,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-4.7": {
		id: "zai-org/GLM-4.7",
		name: "GLM-4.7",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.2,
			cacheRead: 0.11,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-4.7-Flash": {
		id: "zai-org/GLM-4.7-Flash",
		name: "GLM-4.7-Flash",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 128000,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-5": {
		id: "zai-org/GLM-5",
		name: "GLM-5",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1,
			output: 3.2,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-5.1": {
		id: "zai-org/GLM-5.1",
		name: "GLM-5.1",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1,
			output: 3.2,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"zai-org/GLM-5.2": {
		id: "zai-org/GLM-5.2",
		name: "GLM-5.2",
		api: "openai-completions",
		provider: "huggingface",
		baseUrl: "https://router.huggingface.co/v1",
		compat: {"supportsDeveloperRole":false},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
} as const;
